import type { DeliveryItem, DisplayDaysSettingItem, TableHeader } from "./types";

export const DELIVERY_SETTING_FILE_NAME = "DeliverySetting";

/**
 * 配達便選択肢
 */
export const DELIVERY_ITEMS: DeliveryItem[] = [
  { label: "都度便", delivery_id: 0 },
  { label: "１便", delivery_id: 1 },
  { label: "２便", delivery_id: 2 },
  { label: "３便", delivery_id: 3 },
  { label: "４便", delivery_id: 4 },
  { label: "５便", delivery_id: 5 },
  { label: "６便", delivery_id: 6 },
  { label: "７便", delivery_id: 7 },
  { label: "８便", delivery_id: 8 },
  { label: "９便", delivery_id: 9 },
  { label: "１０便", delivery_id: 10 },
];

/**
 * グループ便選択肢
 */
export const GROUP_DELIVERY_ITEMS: DeliveryItem[] = [...DELIVERY_ITEMS];

/**
 * 配達便の選択ボックス（表示設定）
 */
export const DISPLAY_DAYS_SETTING_ITEMS: DisplayDaysSettingItem[] = [
  { label: "当日", display_days_setting: 0 },
  { label: "翌日まで", display_days_setting: 1 },
  { label: "2日後まで", display_days_setting: 2 },
  { label: "3日後まで", display_days_setting: 3 },
  { label: "4日後まで", display_days_setting: 4 },
  { label: "5日後まで", display_days_setting: 5 },
  { label: "6日後まで", display_days_setting: 6 },
  { label: "7日後まで", display_days_setting: 7 },
  { label: "8日後まで", display_days_setting: 8 },
  { label: "9日後まで", display_days_setting: 9 },
];

/**
 * 一覧表示ヘッダー定義
 */
export const TABLE_HEADERS: TableHeader[] = [
  { title: "配達便", align: "center", sortable: false, key: "delivery_id" },
  { title: "配達時刻", align: "center", sortable: false, key: "delivery_time" },
  { title: "基本キャップ", align: "center", sortable: false, key: "max_deliverable_unit" },
  { title: "月", align: "center", sortable: false, key: "delivery_cap_mon" },
  { title: "火", align: "center", sortable: false, key: "delivery_cap_tue" },
  { title: "水", align: "center", sortable: false, key: "delivery_cap_wed" },
  { title: "木", align: "center", sortable: false, key: "delivery_cap_thu" },
  { title: "金", align: "center", sortable: false, key: "delivery_cap_fri" },
  { title: "土", align: "center", sortable: false, key: "delivery_cap_sat" },
  { title: "日", align: "center", sortable: false, key: "delivery_cap_sun" },
  { title: "表示設定", align: "center", sortable: false, key: "display_days_setting" },
  { title: "", align: "center", sortable: false, key: "actions" },
];

/**
 * グループ便一覧ヘッダー定義
 */
export const GROUP_TABLE_HEADERS: TableHeader[] = [
  { title: "配達グループ名称", align: "center", sortable: false, key: "name" },
  { title: "配達便", align: "center", sortable: false, key: "group_delivery_id_name" },
  { title: "対象エリア・便", align: "center", sortable: false, key: "assigned_id_list" },
  { title: "基本キャップ", align: "center", sortable: false, key: "max_deliverable_unit" },
  { title: "月", align: "center", sortable: false, key: "group_cap_mon" },
  { title: "火", align: "center", sortable: false, key: "group_cap_tue" },
  { title: "水", align: "center", sortable: false, key: "group_cap_wed" },
  { title: "木", align: "center", sortable: false, key: "group_cap_thu" },
  { title: "金", align: "center", sortable: false, key: "group_cap_fri" },
  { title: "土", align: "center", sortable: false, key: "group_cap_sat" },
  { title: "日", align: "center", sortable: false, key: "group_cap_sun" },
  { title: "", align: "center", sortable: false, key: "actions" },
];

/**
 * 対象エリア・便追加ヘッダー定義
 */
export const AREA_DELIVERY_ID_RESIST_HEADERS: TableHeader[] = [
  { title: "店舗名", align: "center", sortable: false, key: "shop_name" },
  { title: "エリア", align: "center", sortable: false, key: "area_name" },
  { title: "便", align: "center", sortable: false, key: "delivery_id" },
  { title: "配達時間", align: "center", sortable: false, key: "delivery_time" },
  { title: "", align: "center", sortable: false, key: "actions" },
];
